import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import theme from '../theme';
import logo from '../assets/images/logo.png';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) setMenuOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleNavClick = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  const styles = {
    nav: {
      backgroundColor: theme.colors.background,
      borderBottom: `1px solid ${theme.colors.border}`,
      position: 'sticky',
      top: 0,
      zIndex: 1000,
      boxShadow: theme.shadows.sm,
    },
    container: {
      maxWidth: '1280px',
      margin: '0 auto',
      padding: `${theme.spacing.sm} ${theme.spacing.md}`,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    logo: {
      textDecoration: 'none',
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing.xs,
    },
    logoImage: {
      height: isMobile ? '40px' : '56px',
      width: 'auto',
      display: 'block',
    },
    logoText: {
      fontSize: isMobile ? theme.typography.fontSize.xl : theme.typography.fontSize['2xl'],
      fontWeight: theme.typography.fontWeight.bold,
      color: theme.colors.text,
      fontFamily: theme.typography.fontFamily.heading,
      lineHeight: 1,
    },
    navLinks: {
      display: 'flex',
      gap: theme.spacing.md,
      listStyle: 'none',
      margin: 0,
      padding: 0,
    },
    link: {
      color: theme.colors.text,
      textDecoration: 'none',
      fontSize: theme.typography.fontSize.base,
      fontWeight: theme.typography.fontWeight.medium,
      fontFamily: theme.typography.fontFamily.primary,
      transition: theme.transitions.fast,
    },
    hamburger: {
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      width: '28px',
      height: '20px',
      padding: 0,
    },
    bar: {
      display: 'block',
      width: '100%',
      height: '3px',
      backgroundColor: theme.colors.primary,
      borderRadius: '2px',
      transition: theme.transitions.fast,
    },
    mobileMenu: {
      backgroundColor: theme.colors.background,
      borderTop: `1px solid ${theme.colors.border}`,
      padding: `${theme.spacing.md} ${theme.spacing.md}`,
    },
    mobileNavLinks: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing.sm,
    },
    mobileLink: {
      color: theme.colors.text,
      textDecoration: 'none',
      fontSize: theme.typography.fontSize.lg,
      fontWeight: theme.typography.fontWeight.medium,
      fontFamily: theme.typography.fontFamily.primary,
      padding: `${theme.spacing.sm} 0`,
      display: 'block',
      cursor: 'pointer',
      borderBottom: `1px solid ${theme.colors.border}`,
    },
  };

  return (
    <nav style={styles.nav}>
      <div style={styles.container}>
        <Link to="/" style={styles.logo} onClick={() => setMenuOpen(false)}>
          <img src={logo} alt="WODGoat" style={styles.logoImage} />
          <span style={styles.logoText}>WODGoat</span>
        </Link>

        {isMobile ? (
          <button
            style={styles.hamburger}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span style={styles.bar}></span>
            <span style={styles.bar}></span>
            <span style={styles.bar}></span>
          </button>
        ) : (
          <ul style={styles.navLinks}>
            <li>
              <Link
                to="/"
                style={styles.link}
                onMouseOver={(e) => e.target.style.color = theme.colors.primary}
                onMouseOut={(e) => e.target.style.color = theme.colors.text}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/privacy"
                style={styles.link}
                onMouseOver={(e) => e.target.style.color = theme.colors.primary}
                onMouseOut={(e) => e.target.style.color = theme.colors.text}
              >
                Privacy
              </Link>
            </li>
            <li>
              <Link
                to="/terms"
                style={styles.link}
                onMouseOver={(e) => e.target.style.color = theme.colors.primary}
                onMouseOut={(e) => e.target.style.color = theme.colors.text}
              >
                Terms
              </Link>
            </li>
          </ul>
        )}
      </div>

      {isMobile && menuOpen && (
        <div style={styles.mobileMenu}>
          <ul style={styles.mobileNavLinks}>
            <li>
              <span
                style={styles.mobileLink}
                onClick={() => handleNavClick('/')}
              >
                Home
              </span>
            </li>
            <li>
              <span
                style={styles.mobileLink}
                onClick={() => handleNavClick('/privacy')}
              >
                Privacy
              </span>
            </li>
            <li>
              <span
                style={{ ...styles.mobileLink, borderBottom: 'none' }}
                onClick={() => handleNavClick('/terms')}
              >
                Terms
              </span>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
